//提前加载图片
const preloadImages = () => {
    for(let i=1;i<26;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nrc_box8_${i}.avif?v=1754906192`;
    }
};
preloadImages()

function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

if(window.innerWidth>750){
    var wFlag=true
}else{
    wFlag=false
}

$(()=>{
    setTimeout(() => {
        $('.box1_title').addClass('showup')
        $('.box1_icon').addClass('showup')
    }, 200);

    showUp('.box2_title')

    gsap.from('.box2_item',{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:'.box2_item',
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                // console.log(index)
                if(index>5){
                    // 执行一次
                    if(timeFlag){
                        startTime()
                        timeFlag=false;
                    }
                }else{
                    // 重置
                    timeFlag=true,num1 = 150
                }
            },
        }
    })

    var num1 = 170,timeFlag=true,IntervalFlag;
    function startTime(){
        IntervalFlag =  setInterval(updateInfo,30)
    }
    function updateInfo(){
        num1++;
        $(`.box2_item div:nth-child(1) span`).text(`${num1}%`)
        $(`.box2_item div:nth-child(2) span`).text(`${num1-80}ML`)
        $(`.box2_item div:nth-child(3) span`).text(`${num1-100}%`)
        if(num1 > 199){
            clearInterval(IntervalFlag);
        }
    }

    showUp('.box3_title')

    //box4
    var $video = $('#box4Video');

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top center',
            end:'+=15%',
            scrub:1,
            // markers:true,
            //toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .from('.box4_title',{scale:4,opacity:0,ease:'none'})
        })

        ScrollTrigger.create({
            trigger:'.box4',
            start:'top+=20% top+=6%',
            end:'+=60%',
            scrub:true,
            // markers:true,
            onUpdate: function (self) {
                //$video[0].duration
                $video[0].currentTime = self.progress * 2.2;
                if($video[0].currentTime>0.1){
                    $('.box4t_flag').css({opacity:0})
                    $('.box4v_flag').css({opacity:1})
                }else{
                    $('.box4t_flag').css({opacity:1})
                    $('.box4v_flag').css({opacity:0})
                }
            }
        })

        ScrollTrigger.create({
            trigger:'.box4',
            start:'top+=100% top+=6%',
            end:'+=30%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .to('#box4Video',{scale:0.55,x:'10%',y:'-6%',opacity:0})
                .from('.box6',{opacity:0},'-=50%')
        })

        ScrollTrigger.create({
            trigger:'.box4',
            start:'top+=180% top+=6%',
            end:'+=30%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .from('.box6_item div img',{opacity:0})
                .from('.box6_item div:nth-child(2) p:nth-child(2)',{opacity:0},'<')
                .to('.box6_item div:nth-child(1)',{background:'white'},'-=50%')
                .to('.box6_item div:nth-child(1) video',{opacity:0},'-=50%')
        })
        
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=6%',
            end:'+=230%',
            pin:true,
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top+=13% top+=6%',
            end:'+=30%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .from('.box6_item div img',{opacity:0})
                .to('.box6_item div:nth-child(1)',{background:'white'},'-=50%')
                .to('.box6_item div:nth-child(1) video',{opacity:0},'-=50%')
                .from('.box6_item div:nth-child(2) p:nth-child(2)',{opacity:0},'<')
        })
        
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top+=13% top+=6%',
            end:'+=40%',
            pin:true
        })
    }
    
    //box5
    showUp('.box5_title')

    ScrollTrigger.create({
        trigger:'.box5_img',
        start:'top center',
        end:'+=0%',
        //markers:true,
        toggleActions:'play none none reverse',
        animation:gsap.timeline().from('.box5_img img:nth-child(2)',{scale:0,duration:1})
    })

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top+=10% top+=6%',
            end:'+=50%',
            scrub:1,
            //markers:true,
            animation:gsap.timeline()
                .to('.box5_1',{opacity:0})
                .to('.box5_imgM',{x:'16rem',y:'5rem',scale:1.6},'-=50%')
                .from('.box5_2',{opacity:0},'-=50%')
        })
    
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top+=120% top+=6%',
            end:'+=20%',
            //markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                if(index>30){
                    $('.box5_content').css({transform:'translate(-52%)'})
                }else{
                    $('.box5_content').css({transform:'translate(0)'})
                }
            }
        })
    
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top top+=15%',
            end:'+=160%',
            pin:true,
            //markers:true,
        })
    }else{
        showUp('.box5_title2')
    
        ScrollTrigger.create({
            trigger:'.box5_2',
            start:'top top+=8%',
            end:'+=30%',
            pin:true,
            //markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                if(index>30){
                    $('.box5_content').css({transform:'translate(-52%)'})
                }else{
                    $('.box5_content').css({transform:'translate(0)'})
                }
            }
        })
    }
    
    //box8
    ScrollTrigger.create({
        trigger:'.box8',
        start:'top top+=46%',
        end:'+=80%',
        // markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 24);
            $('.box8_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nrc_box8_${index+1}.avif?v=1754906192`)
        }
    })
    ScrollTrigger.create({
        trigger:'.box8',
        start:'top+=60% top+=6%',
        end:'+=40%',
        scrub:1,
        // markers:true,
        animation:gsap.timeline()
            .to('.box8_img',{opacity:wFlag?0.3:1})
            .from('.box8_title',{y:'2rem',opacity:0},'-=50%')
            .from('.box8_content img',{y:'2rem',opacity:0},'-=50%')
            .from('.box8_item',{y:'2rem',opacity:0},'-=50%')
    })
    
    ScrollTrigger.create({
        trigger:'.box8',
        start:'top top+=6%',
        end:'+=120%',
        pin:true,
        //markers:true,
    })
    
    //box7
    showUp('.box7_title')

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box7_items',
            start:'top bottom-=30%',
            end:'+=20%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .from('.box7_items .box7_item:nth-child(1)',{x:'106%',opacity:0})
                .from('.box7_items .box7_item:nth-child(3)',{x:'-106%',opacity:0},'<')
        })
    }else{
        $('.box7_nav div').click(function(){
            var index = $(this).index();
            $('.box7_nav div').removeClass('box7_active')
            $(this).addClass('box7_active')
            $('.box7_items .box7_item').hide()
            $('.box7_items .box7_item').eq(index).show()
        })
    }
    
    //box9
    showUp('.box9_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box9_items',
            start:'top bottom-=20%',
            end:'+=0%',
            // markers:true,
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .from('.box9_left',{x:'-32%',opacity:0})
                .from('.box9_right',{x:'55%',opacity:0},'<')
                .to('.box9_icon',{opacity:1},'-=50%')
        })
    }

    //box10
    showUp('.box10_title')
    new Swiper('.box10Swiper', {
        //autoplay: true,
        pagination: {
            el: '.box10Swiper-pagination',
            clickable:true
        },
    })
})